var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDriverSelectYes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.668 16.001c0-7.364 5.97-13.333 13.333-13.333 7.364 0 13.334 5.97 13.334 13.333 0 7.364-5.97 13.334-13.334 13.334S2.668 23.365 2.668 16zm18.276-1.724a1.333 1.333 0 1 0-1.886-1.885l-4.39 4.39-1.724-1.723a1.333 1.333 0 1 0-1.886 1.885l2.667 2.667c.52.52 1.365.52 1.886 0l5.333-5.334z",
    fill: "#34a853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDriverSelectYes);
export default __webpack_public_path__ + "static/media/icon_driver-select-yes.445f5e5a128ff8e5519fba004e40fc6a.svg";
export { ForwardRef as ReactComponent };